import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { EntitesDadosEstoque } from "app/components/Estoque/Estoque"
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto"
import { useMenuSubConsulta } from "app/components/menu-sub-consulta-produto/useMenuSubConsultaProduto"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { EntitesReservaProduto, ReservaProduto } from "./Reservaproduto"
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";

export type ReservaProdutoContainerProps = {
    estoqueSelecionado: EntitesDadosEstoque
    item: IItemOrcamento
    //dadosEstoque: PagedMessageResponse<EntitesDadosEstoque>
    onVoltar: () => void, 
    onRemover: () => void,
    passos: Dict<string,() => void>,
    foraOrcamento: boolean
}

export const ReservaProdutoContainer = (props: ReservaProdutoContainerProps) => {

    const [dadosReservaProduto, setDadosReservaProduto] = useState<PagedMessageResponse<EntitesReservaProduto>>()
    const [parametros, setParametros] = useState<Parametro[]>([])
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map))) 

    const atualizarParametros = async () => {
        const parametros = await obterParametros({ 
            nomes: [
              "UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA", // 487678
              "TRATAR_VENDAS_SOB_ENCOMENDA"
            ]
          })
        setParametros(parametros)

        // obterParametrosPorOidItem({
        // nomes: [
        //     "UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA", // 487678
        // ],
        // oidItem: orcamento.OidFilialOrcamento
//    })
      }

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;
  
    const onObterReserva = async () => {
        try {
            const resposta = await microuniversoApi.Produto.dadosReservaProduto({
                Codigo: props.estoqueSelecionado.Codigo,
                CodigoFilial: props.estoqueSelecionado.Filial,
                NumeroPagina: 1,
                TamanhoPagina: 1000
            }) 
            !("HasErrors" in resposta) ? setDadosReservaProduto(resposta) : setDadosReservaProduto({})
            
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    useMenuSubConsulta(props)
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.remove("Estoque do Produto").map)), props.onVoltar, props.item, props.foraOrcamento)

    useEffect(() => {
        passosInterno.current.set("Estoque do Produto", () => props.onVoltar())
        passosInterno.current.set("Reserva do Produto", () => { })
        onObterReserva()
        atualizarParametros()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                id="ReservaProdutoContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
            />
            <br />
            <ReservaProduto 
                dados={dadosReservaProduto} 
                parametros={parametros} // 487678
                mostrarColunaEncomenda={parseInt(valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA")) > 0}
            />
        </>
    )
}